import { Dispatch, SetStateAction, useContext } from 'react'

import { ErrorsContext } from '@/contexts/error'

interface UseFormErrorsProps {
  formErrors: Record<string, string | undefined> | null
  addFormError: (id: string, error: string) => void
  clearFormErrors: () => void
  clearFormError: (id: string) => void
  getFieldError: (id: string) => string | undefined
  setFormErrors: Dispatch<SetStateAction<Record<string, string | undefined> | null>>
}

export const useFormErrors = (): UseFormErrorsProps => {
  const { formErrors, setFormErrors } = useContext(ErrorsContext)

  const addFormError = (id: string, error: string) => {
    setFormErrors((prev) => {
      if (!prev) return { [id]: error }

      return {
        ...prev,
        [id]: error
      }
    })
  }

  const clearFormErrors = () => {
    setFormErrors(null)
  }

  const clearFormError = (id: string) => {
    setFormErrors((prev) => {
      if (!prev) return null

      return {
        ...prev,
        [id]: undefined
      }
    })
  }

  const getFieldError = (id: string) => {
    if (!formErrors) return undefined
    return formErrors[id]
  }

  return {
    formErrors,
    addFormError,
    clearFormErrors,
    clearFormError,
    getFieldError,
    setFormErrors
  }
}
